import DobovoTab from './DobovoTab'

export default DobovoTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/DobovoTab/index.js